var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Navigation',{attrs:{"fav-icon":_vm.logo,"breakpoint":1200}}),_vm._v(" "),_c('Nuxt'),_vm._v(" "),_c('ScrollTop'),_vm._v(" "),_c('compare-lenders-popup'),_vm._v(" "),_c('Footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }